import React from 'react';

/**
 * Caller info template
 */
export const CallerTemplate: React.FC<{ callBy: string; callTo: string }> = ({
  callBy,
  callTo,
}) => {
  return (
    <div
      style={{
        padding: '8px 4px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          fontWeight: 500,
          fontSize: '0.875rem',
          color: '#1e293b',
          lineHeight: 1.2,
        }}
      >
        {callBy}
      </div>
      <div
        style={{
          fontSize: '0.75rem',
          color: '#64748b',
          lineHeight: 1.2,
          marginTop: '2px',
        }}
      >
        Called: {callTo}
      </div>
    </div>
  );
};

export default CallerTemplate;
